import "../assets/AssistantChatScrollReversed.css";
import { jsxs as Y, jsx as b } from "react/jsx-runtime";
import ot, { forwardRef as lt, useMemo as B, Children as rt, useState as v, useCallback as g, useEffect as S, useImperativeHandle as nt } from "react";
import { useElementPos as it } from "./useElementPos.js";
import { u as at } from "../index-2kwedRtj.mjs";
import { useAssistantChatScrollReversedProps as ct, defaultPrependTargetIndex as dt } from "./AssistantChatScrollReversedProps.js";
import { FirstMessagePositioning as K } from "./types.js";
const mt = "_root_1pqhk_1", ft = "_scrollBlock_1pqhk_5", ht = "_scrollable_1pqhk_13", gt = "_wrapper_1pqhk_17", ut = "_absolutePos_1pqhk_27", xt = "_item_1pqhk_36", bt = "_loader_1pqhk_47", u = {
  root: mt,
  scrollBlock: ft,
  scrollable: ht,
  wrapper: gt,
  absolutePos: ut,
  item: xt,
  loader: bt
}, wt = lt((U, W) => {
  const {
    style: N,
    children: H,
    scrollFollowOffsetPx: G,
    scrollLoadHistoryOffsetPx: O,
    scrollLoadHistoryWorker: _,
    estimateSizePx: J,
    loader: V,
    overscan: Q,
    paddingStart: p,
    paddingStartFirstMessage: I,
    paddingEnd: X,
    appendScrollTargetIndex: q,
    scrollAlignment: M,
    getScrollButton: w,
    itemClassName: $,
    scrollToLastOnAppend: z,
    firstMessagePosition: P
  } = ct(U), Z = B(
    () => O + p,
    [p, O]
  ), s = B(() => rt.toArray(H).reverse(), [H]), [c, C] = v(!1), R = g(async () => {
    c || (C(!0), await _(), C(!1));
  }, [c, _]), i = ot.useRef(null), { pos: F, scrollPos: l } = it(i), [d, D] = v(!0), [m, tt] = v(null), [x, j] = v(0), [r, et] = v(P === K.start), n = at({
    count: s.length,
    getScrollElement: () => i.current,
    estimateSize: () => J,
    getItemKey: (t) => s[t].key ?? t,
    paddingEnd: p,
    paddingStart: X,
    overscan: Q
  }), o = n.getVirtualItems();
  S(() => {
    if (P === K.start && o.length) {
      const t = o[0].index === 0 && o[o.length - 1].end + I < F.height;
      r !== t && et(t);
    }
  }, [P, r, I, F.height, o]);
  const k = g(() => dt({ childrenArray: s, visibleItem: m, scrollPos: l }) ?? -1, [s, l, m]), y = g(() => {
    if (o.length) {
      const t = o.find((e) => e.end >= l.bottom) ?? o[o.length - 1];
      tt({
        key: t.key,
        start: t.start,
        index: t.index,
        bottom: l.bottom
      });
    }
  }, [l.bottom, o]), f = g((t, e) => {
    if (!s.length)
      return;
    const a = (e == null ? void 0 : e.animate) ?? !0, h = (e == null ? void 0 : e.align) ?? M, E = (s.length - t - 1) % s.length;
    n.scrollToIndex(E, { align: h, behavior: a ? "smooth" : void 0 }), setTimeout(() => {
      n.scrollToIndex(E, { align: h, behavior: void 0 });
    }, 500);
  }, [s.length, M, n]), T = g(() => {
    if (!c && !r && i.current && s.length) {
      const t = k(), e = m ? m.index : s.length, a = t > e, h = x + Math.max(0, t - e);
      if (h !== x && j(h), a && m) {
        const st = n.getOffsetForIndex(t, "start")[0] - m.start;
        n.scrollBy(st), z ? f(-1, { animate: !0, align: "start" }) : d && s.length && f(q({ childrenArray: s, scrollPos: l }), { animate: !0, align: "start" });
      }
    }
  }, [c, r, s, k, m, x, n, z, d, f, q, l]), L = g(async () => {
    !_ || c || r || await R();
  }, [c, r, R, _]);
  nt(W, () => ({
    getAnchorIndex: k,
    saveScrollPosition: y,
    scrollToIndex: f,
    restoreScrollPosition: T,
    loadHistory: L
  }), [k, L, T, y, f]);
  const A = g((t) => {
    if (i.current) {
      const { deltaY: e } = t;
      Math.abs(e) && (i.current.scrollTop -= e, t.preventDefault());
    }
  }, []);
  return S(() => {
    if (i.current)
      return i.current.addEventListener("wheel", A), () => {
        var t;
        return (t = i.current) == null ? void 0 : t.removeEventListener("wheel", A);
      };
  }, [A]), S(() => {
    y();
    const t = l.maxBottom - l.bottom;
    if (t !== 0 && t < Z && L(), l.bottom < G ? d || D(!0) : d && D(!1), o.length) {
      const a = (o.find((h) => h.end >= l.bottom) ?? o[0]).index;
      a < x && j(a);
    }
  }, [d, l]), S(() => {
    T(), y();
  }, [s]), B(() => {
    var t;
    return /* @__PURE__ */ Y("div", { style: N, className: `${u.root} ${!r && u.scrollable}`, children: [
      w && !d && w({
        newItems: x,
        scrollToIndex: f
      }),
      /* @__PURE__ */ b("div", { className: u.scrollBlock, ref: i, children: /* @__PURE__ */ b(
        "div",
        {
          className: u.wrapper,
          style: r ? { paddingBottom: `${I}px` } : { height: n.getTotalSize() },
          children: /* @__PURE__ */ Y(
            "div",
            {
              className: u.absolutePos,
              style: r ? {
                bottom: 0
              } : {
                transform: `translateY(${((t = o[0]) == null ? void 0 : t.start) ?? 0}px)`
              },
              children: [
                o.map((e) => {
                  const a = s[e.index];
                  return /* @__PURE__ */ b(
                    "div",
                    {
                      "data-index": e.index,
                      ref: n.measureElement,
                      className: `${u.item} ${$}`,
                      children: a
                    },
                    a.key
                  );
                }),
                /* @__PURE__ */ b("div", { className: u.loader, children: /* @__PURE__ */ b("div", { children: c && V }) })
              ]
            }
          )
        }
      ) })
    ] });
  }, [N, w, d, x, f, n, r, o, c, V, s, $]);
});
export {
  wt as AssistantChatScrollReversed
};
